import {
	ChangeDetectorRef,
	Component,
	EventEmitter,
	Input,
	OnChanges,
	Output,
	SimpleChanges,
	ViewChild
} from '@angular/core';
import { IMyDpOptions } from 'mydatepicker';
import { NgForm } from '@angular/forms';
import { InvoicePayment, PaymentToRecord } from '@models/models';
import { MessageService } from '@services/helpers/message-service/message.service';
import { TimeServiceProvider } from '@services/helpers/time-service/time.service';
import { InvoicesDataProvider } from '@services/invoice/invoices-data-service/invoices.data.service';
import { AllowedPlaces } from '@models/messages';
import { SettingsProvider } from '@services/settings/settings';
import { createNumberMask } from 'text-mask-addons/dist/textMaskAddons';
import { StringModifierServiceProvider } from '@services/helpers/string-modifier-service/stringModifier.service';
import { AmountValidationDirective } from '../../../../directives/AmountValidation/amountValidation.directive';

@Component({
	selector: 'record-payment-modal',
	template: require('./record-payment-modal.html')
})
export class RecordPaymentModalComponent implements OnChanges {
	@Input() selectedPayment: InvoicePayment;
	@Output() updateParent: EventEmitter<boolean> = new EventEmitter<boolean>();
	@ViewChild(AmountValidationDirective)
	amountValidationDirective: AmountValidationDirective;

	paidOn: object;
	disableButtons: boolean;
	recordPaymentSpinningWheel: boolean;
	amount: number;
	myDatePickerOptions: IMyDpOptions;
	dateFormat: string;
	weekStartsOn: string;
	currencySymbol = '$';

	numberMask = createNumberMask({
		prefix: '',
		suffix: '',
		allowDecimal: true,
		allowLeadingZeroes: true
	});

	constructor(
		private messageService: MessageService,
		private timeService: TimeServiceProvider,
		private invoicesDataService: InvoicesDataProvider,
		private ref: ChangeDetectorRef,
		private settingsService: SettingsProvider,
		private stringModifier: StringModifierServiceProvider
	) {}

	ngOnChanges(changes: SimpleChanges) {
		const selectedPayment = changes.selectedPayment.currentValue;
		if (selectedPayment) {
			this.amount = selectedPayment.amount;
			this.paidOn = { jsdate: new Date() };
			this.currencySymbol = selectedPayment.currencySymbol;
		}
	}

	closeModal() {
		this.amount = this.selectedPayment.amount;
		this.amountValidationDirective.showValidation(this.selectedPayment.amount);
	}

	markAsPayed(form: NgForm): void {
		this.recordPaymentSpinningWheel = true;
		this.disableButtons = true;

		const paidOnFormatted: Date = this.timeService.getDateInFormat(
			form.value._paidOn.jsdate,
			'date'
		);

		const amountFormatted: number = this.stringModifier.convertAmountIntoNumber(
			form.value._amount
		);

		const data: PaymentToRecord = {
			id: this.selectedPayment.id,
			amount: amountFormatted,
			paidOn: paidOnFormatted
		};

		this.invoicesDataService
			.markAsPaid(data)
			.finally(() => {
				this.recordPaymentSpinningWheel = false;
				this.disableButtons = false;
			})
			.subscribe(
				data => this.successMarkAsPaid(data),
				err => this.errorMarkAsPaid(err)
			);
	}

	private successMarkAsPaid(data: any): void {
		if (data && data.errorMessage) {
			if (data.errorCode) {
				this.handleModernErrorMessages(data);
				return;
			}
			toastr.error(data.errorMessage);
		} else {
			$('#markAsPayedModal').modal('hide');
			this.messageService.showToaster('s_7', 'payments');
			this.updateParent.emit(true);
		}
	}

	private errorMarkAsPaid({
		status,
		data
	}: {
		status: number;
		data: any;
	}): void {
		if (data.errorCode) {
			this.handleModernErrorMessages(data);
			return;
		}

		const errorMessage: string = data.errorMessage;
		let errorCode: string;
		let errorPlace: AllowedPlaces;
		let value: any;

		if (status >= 400 && status < 500 && errorMessage) {
			switch (errorMessage) {
				case 'Payment already paid':
					errorCode = 'e_10';
					errorPlace = 'editInvoice';
					break;
				case "Xero payments don't match StudioNinja payments":
					errorCode = 'e_0';
					errorPlace = 'xero';
					break;
				case 'Invoice not synchronized with Xero':
					errorCode = 'e_9';
					errorPlace = 'xero';
					break;
				case "Bummer! You don't have an active Xero subscription.":
					errorCode = 'e_15';
					errorPlace = 'xero';
					break;
				case 'Xero access token expired, reconnect Xero please':
				case 'Bummer! Xero access token not authorized or revoked, reconnect Xero please':
				case 'Bummer! Xero access token revoked, reconnect Xero please':
					errorCode = 'e_14';
					errorPlace = 'xero';
					break;
				default:
					errorCode = 'e_2';
					errorPlace = 'general';
					value = errorMessage;
					break;
			}
		} else {
			errorCode = 'e_0';
			errorPlace = 'general';
		}
		this.messageService.showToaster(errorCode, errorPlace, value);
	}

	private handleModernErrorMessages({ errorTitle, errorMessage }): void {
		this.messageService.showErrorFromBackend(errorTitle, errorMessage);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./web/modern/components/payments/modals/record-payment-modal/record-payment-modal.ts